import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';

/**
 * Makes a user-typed search term safe to sit in a URL path segment.
 *
 * These endpoints take the term as a path segment, and the term was being run
 * through encodeURI(), which leaves / ? # & + ; = $ : @ and , untouched. A term
 * like "Sr Business/Data Analyst" therefore split the path into an extra segment
 * and the request 404'd on every keystroke; "?" or "#" would have truncated the
 * URL outright.
 *
 * encodeURIComponent() covers all of those, and the API accepts every one of
 * them percent-encoded - except %2F, which it still 404s. So a slash is turned
 * into a space first: "Sr Business/Data Analyst" searches as
 * "Sr Business Data Analyst", and skills like "CI/CD" as "CI CD".
 */
export function encodeSearchTerm(text: any): string {
	const cleaned = String(text ?? '')
		.replace(/[\/\\]+/g, ' ')
		.replace(/\s+/g, ' ')
		.trim();
	return encodeURIComponent(cleaned);
}

/** The shape these endpoints return, for when there is nothing worth asking. */
export const EMPTY_AUTOCOMPLETE_RESULT = { Code: 200, Result: 'Success', Data: [] as any[] };

@Injectable()
export class AutocompleteService {
	private serverUrl = environment.urls.serverUrl_Obj;

	constructor(private http: HttpClient) { }

	get(text: any, type: any) {
		const term = encodeSearchTerm(text);
		if (!term) {
			// nothing left once the path-hostile characters are gone; asking would
			// only produce a guaranteed 404
			return of(EMPTY_AUTOCOMPLETE_RESULT);
		}
		return this.http.get(`${this.serverUrl}autocomplete/${type}/${term}`);
	}

}
